import { render } from "./ProductMappingEdit.vue?vue&type=template&id=4bcbb9cd&scoped=true"
import script from "./ProductMappingEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductMappingEdit.vue?vue&type=script&setup=true&lang=js"

import "./ProductMappingEdit.vue?vue&type=style&index=0&id=4bcbb9cd&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bcbb9cd"],['__file',"resources/js/modules/product-mapping/components/ProductMappingEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4bcbb9cd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4bcbb9cd', __exports__)) {
    api.reload('4bcbb9cd', __exports__)
  }
  
  module.hot.accept("./ProductMappingEdit.vue?vue&type=template&id=4bcbb9cd&scoped=true", () => {
    api.rerender('4bcbb9cd', render)
  })

}


export default __exports__